<template>
    <div class="overflow-x-hidden relative">
        <section class="text-center grid flex flex-wrap justify-content-center align-items-center py-4 md:px-4 md:px-6 relative">
            <img src="@/assets/Images/bird.png" alt="" class="decoration">
            <div class="col-10 py-6">
                <span class="badge mb-2">Different</span>
                <h2 class="LandingPage-Title mb-2">
                   What Makes Us Different
                </h2>
                <p class="Paragraph-Medium font-semibold mx-auto">
                   We stand apart from other tutoring platforms through our unique approach to personalized learning
                </p>
            </div>
            <div class="grid md:pt-4 relative">
                <div v-for="(feature, index) in features" :key="index" class="col-12 md:col-6 lg:col-3">
                    <div class="feature-item text-center px-2" v-animateonscroll="{ enterClass: 'animate-zoom-in'}">
                        <div
                            class="feature-icon w-4rem h-4rem flex align-items-center justify-content-center mx-auto mb-4 border-round-lg">
                            <i :class="feature.icon" class="text-gray-600 text-2xl"></i>
                        </div>
                        <p class="Paragraph-Regular font-semibold mb-0 ">{{ feature.title }}</p>
                        <p class="Paragraph-Regular font-semibold mb-0 mt-0">{{ feature.description }}</p>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>


const features = [
    {
        icon: "pi pi-graduation-cap",
        title: "Verified Tutors",
        description: ""
    },
    {
        icon: "pi pi-chart-line",
        title: "Smart Tools - ",
        description: "Chat, schedule, and learn online through integrated video tools."
    },
    {
        icon: "pi pi-flag",
        title: "Built for Sri Lanka - ",
        description: "Local languages, local culture, global standards."
    },
    {
        icon: "pi pi-book",
        title: "Island-Wide Access",
        description: ""
    }
];

</script>
<style scoped>
.feature-icon{
    background-color: #6CD9ED;
}
.decoration {
    position: absolute;
    top: 10%;
    right: 0;
    z-index: 1;
    height: 250px;
    object-fit: contain;
}

/* Responsive styles */
@media (max-width: 768px) {
    .decoration {
        height: 90px;
        top: 30%;
    }
}

@media (max-width: 480px) {
    .decoration {
        height: 150px;
    }
}
</style>